import { render, staticRenderFns } from "./UiLabel.vue?vue&type=template&id=6b3cf2de&scoped=true"
import script from "./UiLabel.vue?vue&type=script&lang=js"
export * from "./UiLabel.vue?vue&type=script&lang=js"
import style0 from "./UiLabel.vue?vue&type=style&index=0&id=6b3cf2de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3cf2de",
  null
  
)

export default component.exports